import React, { useState } from 'react'
import { useAppDispatch, useAppSelector } from '../store/hooks'
import Steps_en from './steps_en';
import Steps_de from './steps_de';
import Joyride, { ACTIONS, CallBackProps, EVENTS, STATUS, Step } from 'react-joyride';
import { disableTut, enableTut, setStepIndexTut, togglePauseTut } from '../store/tutorial/tutorialSlice';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { Trans } from 'react-i18next';
import i18n from '../locales/i18n';

const Tutorial = ():JSX.Element => {
  const tutorial = useAppSelector(state => state.tutorial);
  const dispatch = useAppDispatch();
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
  const [stepIndex, setStepIndex] = useState(useAppSelector(state => state.tutorial.stepIndex
    ?? 0));

  const handleTutorialClose = (confirm: boolean) => {
    if(confirm === true) {
      setStepIndex(0);
      dispatch(disableTut());
    }
    setCancelDialogOpen(false);
  }

  const resumeAtStep = (step: number) => {
    setStepIndex(step);
    console.log('Step index is manually set to ' + step);
    dispatch(setStepIndexTut(step));
    setTimeout(() => {
      dispatch(togglePauseTut());
    }, 400);
  }
  
  const handleJoyrideCallback = (data: CallBackProps) => {
    const { action, index, status, type } = data;
    console.log(data);

    if( action === 'close') {
      setCancelDialogOpen(true);
    }

    //An pause got triggered by a specific event,
    //now the stepIndex needs to be updated and the tutorial unpaused
    if(([EVENTS.TOUR_STATUS] as string[]).includes(type) && action == 'stop' && !cancelDialogOpen) {
      resumeAtStep(tutorial.stepIndex + 1);
    }

    //All step updates that are triggered by hitting 'Next' button
    if(([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND] as  string[]).includes(type) && action !== 'close') {
      const nextStepIndex = index + (action === ACTIONS.PREV ? -1 : 1);
      console.log('Step index is increased automatically to ' + nextStepIndex);
      setStepIndex(nextStepIndex);
      dispatch(setStepIndexTut(nextStepIndex));
    }
  }

  return (
    <>
      <Joyride
        continuous
        callback={handleJoyrideCallback}
        disableCloseOnEsc
        disableOverlayClose
        spotlightClicks
        stepIndex={stepIndex}
        hideBackButton
        steps={i18n.language === 'en' ? Steps_en : Steps_de} 
        run={(tutorial.active && !tutorial.paused) && !cancelDialogOpen} 
        styles={{
          options: {
            zIndex: 100000,
          },
    }}/>
      <Dialog
        open={cancelDialogOpen}
        onClose={() => handleTutorialClose(false)}
      >
        <DialogTitle>
          <Trans>Abort Tutorial?</Trans>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Trans>
              Are you sure you want to end the tutorial? Your current tutorial progress will be lost. This does not include
              any created pipelines or generated results.
            </Trans>
          </DialogContentText>
        </DialogContent>
          <DialogActions>
            <Button onClick={() => handleTutorialClose(false)}><Trans>No</Trans></Button>
            <Button onClick={() => handleTutorialClose(true)}><Trans>Yes</Trans></Button>
          </DialogActions>
      </Dialog>
    </>
  )
}

export default Tutorial